<template>
	<div id="indexEdit" class="indexEdit clearfix">
		<div class="center-box">
			<preview type='map' ref="Addrobot" openMqtt='1' @attr='Addrobot'></preview>
		</div>
		<AttrBlackboard ref="addrobot" @changeDivSpan="changeDivSpan"></AttrBlackboard>
	</div>
</template>
<script>
	
	import preview from './indexPreview'
	import AttrBlackboard from './preview/AttrBlackboard'
	export default {
		data() {
			
			return {
				
				MqttOption: {}, //mqtt主题配置
				MqttByDataSetUrl: [], //数据集时间范围类型为 实时 情况下的url数组(多个)
				MqttCharts: [/*{id:1,charts: {}}*/], //所有图表init实例化存放数组
				//退订时的回调
				MqttExitBackFunction: {
                    onSuccess(){
                        // console.log("退订成功")
                    },
                    onFailure(error){
                        // console.log("退订失败")
                        // console.log(error)
                    }
                },
                
                userCode: null,//用户code
                companyCode: null,//公司code
			}
		},
		components: {
			preview,
			AttrBlackboard
		},
		computed: {
						
		},
		created() {
			this.$parent.ChangeHeaderShow('hide');

		},
		mounted() {
			this.mqttMSG(); //开启mqtt
			this.getMqttMessage(); //接收mqtt
			
			this.userCode = sessionStorage.getItem('indexMapEditor_user_code')
			this.companyCode = sessionStorage.getItem('indexMapEditor_companyCode')
			
		},
		methods: {
			/*mqtt消息监听*/
			mqttMSG() {
				// mqtt连接
				this.MqttOption = {
					clientId: this.userCode + '_' + this.companyCode + '_rowPreviewMap',
					connectTimeout: 600000,
					clean: true
				}
				this.$store.state.subaru = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, this.MqttOption)
			},
			
			/*接收mqtt*/
			getMqttMessage() {
				// 接收消息处理
				this.$store.state.subaru.on('message', (topic, message) => {
					//console.log(topic,JSON.parse(message.toString()));
					if(topic.indexOf('/property/push') != -1) {
						this.$refs.addrobot.UpdateDataByMqtt(message)
					}
				})
			},
			
			/*改变看板颜色*/
			changeDivSpan(index) {
				this.$refs.Addrobot.changeDivSpan(index);
			},
			
			/*展示实时数据*/
			Addrobot(obj) {
				var self = this;
				if(this.$refs.addrobot.$el.style.display == "" || this.$refs.addrobot.$el.style.display == "none") {
					this.$refs.addrobot.binding(obj);
					this.$refs.addrobot.$el.style.display = "block";
					self.$store.state.mask = true;
					document.getElementsByClassName('mask')[0].style.opacity = '0';
					document.getElementsByClassName('mask')[0].style.transition = '.1s';
					setTimeout(function() {
						self.$refs.addrobot.$el.style.opacity = 1;
						self.$refs.addrobot.$children[0].$el.style.top = 0 + 'px';
						document.getElementsByClassName('mask')[0].style.opacity = '1';
					}, 50)
				} else {
					this.$refs.addrobot.$el.style.opacity = 0;
					self.$refs.addrobot.$children[0].$el.style.top = -50 + 'px';
					self.$store.state.mask = false;
					setTimeout(function() {
						self.$refs.addrobot.$el.style.display = "none";
					}, 100)
				}
			},
		},
	}
</script>
<style scoped>
	.indexEdit{
		width: 100%;
		height: 100%;
	}
	.clearfix:after {
		content: "";
		display: block;
		clear: both;
	}
	* {
		-webkit-touch-callout: none;
		/*系统默认菜单被禁用*/
		-webkit-user-select: none;
		/*webkit浏览器*/
		-khtml-user-select: none;
		/*早期浏览器*/
		-moz-user-select: none;
		/*火狐*/
		-ms-user-select: none;
		/*IE10*/
		user-select: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/MapEditor/Preview/rowPreviewMap.vue